"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateProperties = exports.checkReservedProperties = void 0;

var _includes = _interopRequireDefault(require("lodash/includes"));

var _constants = require("./constants");

var _errors = require("./errors");

var _properties = require("./properties");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkReservedProperties = function checkReservedProperties(properties) {
  if (Object.keys(properties).some(function (x) {
    return (0, _includes.default)(_constants.RESERVED_PROPERTIES, x);
  })) {
    throw new _errors.ReservedPropertyError();
  }
};

exports.checkReservedProperties = checkReservedProperties;

var validateProperties = function validateProperties(location, properties, eventName) {
  var events = _properties.REQUIRED_PROPERTIES[eventName];
  checkReservedProperties(properties);

  if (events[location]) {
    var validatedProperties = {};
    var event = events[location];
    Object.keys(event).forEach(function (property) {
      var validatedProperty;

      if (property in properties) {
        // Test property against the event's validator for that property
        validatedProperty = event[property](properties[property]);
      }

      if (validatedProperty !== undefined) {
        // Our property validators return undefined if the property is invalid
        // and the property value if it is valid
        validatedProperties[property] = validatedProperty;
      } else {
        throw new _errors.InvalidPropertyError(properties[property], property, location);
      }
    });
    return Object.assign(properties, validatedProperties);
  }

  throw new _errors.UnrecognizedTypeError(location, Object.keys(events));
};

exports.validateProperties = validateProperties;